import { render } from "./ButtonOnSubmitEdit.vue?vue&type=template&id=2049150f"
import script from "./ButtonOnSubmitEdit.vue?vue&type=script&lang=js"
export * from "./ButtonOnSubmitEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__